import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#05549f',
    primaryDark: '#034480',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/lukassek-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/lukassek-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/lukassek-logo.png',

    availableProducts: ["Schadenmeldung", "smartKV", "Reparaturnachweis", "Zustandsbericht", "Haftpflichtschaden"],
});